import { render, staticRenderFns } from "./swiper1.vue?vue&type=template&id=d23adac4&scoped=true&"
import script from "./swiper1.vue?vue&type=script&lang=js&"
export * from "./swiper1.vue?vue&type=script&lang=js&"
import style0 from "./swiper1.vue?vue&type=style&index=0&id=d23adac4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23adac4",
  null
  
)

export default component.exports